export default function (ToolbarModule) {
	// Disable the annotation toolbar font size select event (it fires when switching between text annotations with different font sizes).
	ToolbarModule.annotationToolbarModule.onFontSizeChange = new Function();
	// Disable the annotation toolbar font family select event. It fires when selecting a text annotation for the first time since page load
	//   and every time when selecting a text annotation with a different font.
	ToolbarModule.annotationToolbarModule.onFontFamilyChange = new Function();
}